module.exports = __webpack_public_path__ + "img/11.3c97c3c8.png";